export default __webpack_public_path__ + "static/media/scb-logo.dd1a318f.png";